<template>
  <div style="padding-top:30px">
    <div class="win">
      <div class="title" :style="'color:'+data.style.titleColor">
        <p class="fz-26 s_font_b">恭喜中奖</p>
        <p class="fz-14" :style="'color:'+data.style.des_color">您获得了一等奖</p>
      </div>
      <!-- 背景比例 664  844   337 667-->
      <div class="main">

        <div class="item"  :style="'color:'+data.style.color">
          <div class="s_cEF8 icon" >
            <img src="@/assets/images/scan/award_icon_red.png" alt="">
          </div>
          <div class="awardDes">
            <p class="fz-18">1元红包</p>
            <p>红包将在24小时内发放</p>
          </div>
        </div>
        <div class="item"  :style="'color:'+data.style.color">
          <div class="s_cEF8 icon">
            <img src="@/assets/images/scan/award_icon_jf.png" alt="">
          </div>
          <div class="awardDes">
            <p class="fz-18">1积分</p>
            <p>已到账，请前往会员中心查看</p>
          </div>
        </div>
        <div class="item"  :style="'color:'+data.style.color">
          <div class="s_cEF8 icon" >
            <img src="@/assets/images/scan/product_icon.png" alt="">
          </div>
          <div class="awardDes">
            <p class="fz-18">华为p30手机</p>
            <p>请点击按钮领取</p>
          </div>
          <div class="get"  :style="'background-color:'+data.style.btn_color">领取</div>
        </div>
       <div class="item"  :style="'color:'+data.style.color">
          <div class="s_cEF8 icon" >
            <img src="@/assets/images/scan/cut.png" alt="">
          </div>
          <div class="awardDes">
            <p class="fz-18">10.00元优惠券</p>
            <p>已到账，请前往会员中心查看</p>
          </div>
        </div>
      </div>
      <div class="link" :style="'background-color:'+data.style.btn_color">确认</div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
export default {
  name: "win",
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];

    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.win {
  width: 300px;
  height: 500px;
  margin: 0 auto;
  background: linear-gradient(180deg, #fffbf5 0%, #ffe9d7 100%);
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  position: relative;
  border-radius: 10px;
  padding-top: 16px;
  .title {
    text-align: center;
  }
  .main {
    padding: 13px;
    padding-bottom: 0;
    .item {
      background-image: url("../../../../../../../assets/images/scan/award_bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      padding: 14px;
      margin: 10px auto;
      display: flex;
      position: relative;
      font-size: 12px;
      font-weight: 500;
      align-items: center;
      color: #f4261f;
      .icon {
        width: 62px;
        height: 62px;
        background-color: #fff;
        padding: 6px;
        border-radius: 6px;
        margin-right: 14px;
      }
      img {
        width: 100%;
        height: 100%;
      }
      .get {
        background: #f4261f;
        border-radius: 36px;
        font-size: 13px;
        text-align: center;
        line-height: 36px;
        width: 56px;
        height: 36px;
        color: #fff;
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .link {
    font-size: 16px;
    color: #fff;
    width: 150px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    border-radius: 44px;
    background: #f4261f;
    margin: 0 auto;
  }
}
</style>